/**
 * This block is used for Trending Tags, Trending Niches
 * and other stuff like that, where you have a title.
 * a contents, and a see more button.
 */

import { SeeAllButton } from "components/buttons";
import { className } from "@/common/utils/strings";

import "./SeeMoreBlock.scss";

export const SeeMoreBlock = (props: {
  header: string;
  more: string;
  className?: string;
  children: React.ReactElement[];
  list?: boolean;
}) => {
  return (
    <div className={className({
      "seeMoreBlock": true,
      [props.className ?? ""]: true,
    })}>
      <div className="header">
        <h2>{props.header}</h2>
        <SeeAllButton link={props.more} />
      </div>
      <div className={className({
        "contents": true,
        "grid": !props.list,
        "list": !!props.list,
      })}>
        {props.children}
      </div>
      {
        props.children && props.children.length > 0 && (
          <div className="footer">
            <SeeAllButton link={props.more} />
          </div>
        )
      }
    </div>
  );
};
